// @core/api/endpoints/search/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { BulkIndexDocuments } from './bulk_index_documents';
import { CreateSearchIndex } from './create_search_index';
import { DeleteDocument } from './delete_document';
import { DeleteSearchIndex } from './delete_search_index';
import { FederatedSearch } from './federated_search';
import { GetIndexStats } from './get_index_stats';
import { GetSearchIndex } from './get_search_index';
import { IndexDocument } from './index_document';
import { ListSearchIndexes } from './list_search_indexes';
import { ReIndex } from './re_index';
import { Search } from './search';
import { Suggest } from './suggest';
import { UpdateSearchIndex } from './update_search_index';
import { ValidateSearchPolicy } from './validate_search_policy';

// Re-export individual endpoints
export {
  BulkIndexDocuments,
  CreateSearchIndex,
  DeleteDocument,
  DeleteSearchIndex,
  FederatedSearch,
  GetIndexStats,
  GetSearchIndex,
  IndexDocument,
  ListSearchIndexes,
  ReIndex,
  Search,
  Suggest,
  UpdateSearchIndex,
  ValidateSearchPolicy,
};

// Namespace export for convenient usage
export const searchApi = {
  BulkIndexDocuments,
  CreateSearchIndex,
  DeleteDocument,
  DeleteSearchIndex,
  FederatedSearch,
  GetIndexStats,
  GetSearchIndex,
  IndexDocument,
  ListSearchIndexes,
  ReIndex,
  Search,
  Suggest,
  UpdateSearchIndex,
  ValidateSearchPolicy,
};
